import { render, staticRenderFns } from "./NewGanuge.vue?vue&type=template&id=1af64472&scoped=true"
import script from "./NewGanuge.vue?vue&type=script&lang=js"
export * from "./NewGanuge.vue?vue&type=script&lang=js"
import style0 from "./NewGanuge.vue?vue&type=style&index=0&id=1af64472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af64472",
  null
  
)

export default component.exports